// extracted by mini-css-extract-plugin
export default {"virtual-border":"GIAhRdhvZwO2BacuXbCQ","common_bganimation":"I7qdPq7RvQJp1YTWrYgD"};